import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRef } from 'react';
import { usePopper } from '../../../system/hooks/usePopper';
export var useDatePickerPopper = function useDatePickerPopper() {
  var dropdownRef = useRef(null);
  var triggerRef = useRef();

  var _usePopper = usePopper(dropdownRef, triggerRef, 'bottom-start', [0, 5]),
      panelProps = _usePopper.panelProps,
      arrowProps = _usePopper.arrowProps;

  return {
    dropdownProps: _objectSpread({
      ref: dropdownRef
    }, panelProps),
    arrowProps: arrowProps,
    dropdownRef: dropdownRef,
    triggerRef: triggerRef
  };
};